import React, { Component } from "react";
import getContent from "pp-react-l10n";
import VideoModalPlayer from "./VideoModalPlayer";
import getHTMLElement from "../lib/setHtmlHelper";

import { getRandomInt, getColorIdx } from '../lib/brcClientHelper';

class ThankyouArticleList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      articleRedirectFrom: "",
      tilesBundle: [],
      slugId: "",
      isMounted: false
    };
  }

  componentDidMount() {
    const slugId = sessionStorage.getItem("slugId") || "";
    const tilesBundle =
      this.props.articles &&
        this.props.articles.length !== 0 &&
        this.props.articles.length !== undefined
        ? this.props.articles.filter(({ url_slug }) => url_slug !== slugId)
        : [];
    this.setState({
      tilesBundle: tilesBundle,
      slugId,
      isMounted: true
    });
  }

  render() {
    const { tilesBundle, slugId } = this.state;
    const getTilesContent = getContent("staticContent");
    const colorsd = this.props.colors;
    const country = this.props.country.toLowerCase();
    const borderlessCommerceId = "borderless-commerce-ent";
    const fontChange =
      country === "vn" && this.props.locale === "vi_VN" ? "vnFont" : country === 'jp' && this.props.locale === 'ja_JP' ? 'jpFont' : "";

    let updatedTilesBundle = [];
    if (country === "hk" || country === "br" || country === "mx" || country === "sg" || country === "jp" || country === "c2") {
      if (slugId !== "" && slugId === borderlessCommerceId) {
        updatedTilesBundle = tilesBundle;
      } else {
        const missingTile = [
          {
            content: "",
            desc: getTilesContent("brc.mppTileDescription"),
            heading: getTilesContent("brc.mppTileHeading"),
            sm_bg: country === "c2" ? "https://www.paypalobjects.com/marketing/brc/shared/borderless-commerce/4-global-eCommerce-trends-to-watch-thumbnail-1-cn.jpg"
              : "https://www.paypalobjects.com/marketing/brc/shared/borderless-commerce/4-global-eCommerce-trends-to-watch-thumbnail.jpg",
            updated_time: "",
            url_slug: borderlessCommerceId
          }
        ];
        updatedTilesBundle = [...tilesBundle, ...missingTile];
      }
    } else {
      updatedTilesBundle = tilesBundle;
    }

    return (
      <div id="tiles-container" className="thankyouTilesContainer">
        <div className="Maintilescontainer">
          <h2 className={`vx_text-4 tilesheading ${fontChange}`}>
            {getTilesContent("brc.tilesHeader")}
          </h2>
          {updatedTilesBundle.length !== 0 ? (
            <ul className="tiles_list">
              {updatedTilesBundle.map((tile, index) => {
                const listItemId = `tile-list-item-${index}`;
                const bgColor = this.state.isMounted ? colorsd[getRandomInt(0, 6)] : getColorIdx(index, colorsd.length);
                return (
                  <li
                    id={listItemId}
                    className="tile_elements tile_property"
                    style={
                      tile.sm_bg
                        ? {
                          backgroundImage: `url(${tile.sm_bg})`,
                          backgroundColor: bgColor,
                        }
                        : { backgroundColor: bgColor }
                    }
                    key={index}
                  >
                    <a
                      data-pa-click={"tileClick|" + tile.url_slug}
                      className="reqPath"
                      href={
                        tile.url_slug === borderlessCommerceId && country !== "jp" && country !== "c2" ? `/${country}/webapps/mpp/business/borderless-commerce-ent` :
                          tile.url_slug === borderlessCommerceId && (country === "jp" || country === "c2") ? `/${country}/business/borderless-commerce-ent` :
                            this.props.attachUrl.length > 0
                              ? `/${country}/brc/article/${tile.url_slug}?${this.props.attachUrl}`
                              : `/${country}/brc/article/${tile.url_slug}`
                      }
                      key={tile.url_slug + index}
                    >
                      <div
                        className="vx_panel-header tile_header"
                        key={tile.category + index}
                      />
                      <div
                        className={`tileClick|${tile.url_slug}| vx_panel-text tile_sd`}
                        key={tile.heading + index}
                      >
                        {getHTMLElement(tile.heading, { useHTML: true })}{" "}
                      </div>
                    </a>
                    <VideoModalPlayer
                      slugId={tile.url_slug}
                      source={tile.content}
                      id={listItemId}
                    />
                    <p
                      className="vx_text-body tile_description"
                      key={tile.desc + index}
                    >
                      {" "}
                      {getHTMLElement(tile.desc, { useHTML: true })}{" "}
                    </p>
                  </li>
                );
              })}
            </ul>
          ) : (
            <div className={`vx_text-4 tilesheading ${fontChange}`}>
              No articles found.
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ThankyouArticleList;
